import React from 'react';
import classNames from 'classnames';

import passwordValidator from './validator';
import TextField from '../../stateless/textField';

class PasswordField extends React.PureComponent {

  static defaultProps = {
    errorKey: 'password',
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      hasErrors: false,
    };
    this.ref = React.createRef();
  }

  changePasswordVisibility = () => this.setState({ showPassword: !this.state.showPassword });

  validate = (emptyErrors = false) => {
    const { value, noValidate } = this.props;
    const hasErrors = noValidate ? false : emptyErrors ? false : !passwordValidator(value);
    this.setState({ hasErrors });
    this.props.setErrors(hasErrors, this.props.errorKey);
  }

  setFocusedPasswordsState = mode => {
    this.setState({ isFocused: mode });
  }

  handleClickOutside = callback => e => {
    if (this.ref.current && !this.ref.current.contains(e.target)) {
      callback && callback(e);
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside(() => this.setState({ isFocused: false })));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.validate(!this.props.value);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  
  render() {
    const labelClassNames = classNames('label-holder', { 'error': this.state.hasErrors });
    const { showPassword, hasErrors, isFocused } = this.state;
    const { name, showTooltip, setErrors, errorMessage, errorKey, ...rest } = this.props;

    return (
      <label ref={e => this.ref.current = e} className={labelClassNames}>
        <div className="label-title">
          {name}
        </div>
        <div className="input-holder">
          <div className="left-icon icon-lock" />
          <div
            onClick={this.changePasswordVisibility}
            className={classNames('right-icon', { 'icon-eye': !showPassword, 'icon-eye-off': showPassword })}
          />
          <TextField
            onFocus={() => this.setFocusedPasswordsState(true)}
            type={showPassword ? 'text' : 'password'}
            {...rest}
          />
          {showTooltip && isFocused && (
            <div className="val-tooltip">
              <h5>Password must contain:</h5>
              <ul>
                <li>One lowercase character</li>
                <li>One uppercase character</li>
                <li>One number</li>
              </ul>
              <ul>
                <li>One special character</li>
                <li>8 characters minimum</li>
              </ul>
            </div>
          )}
        </div>
        {(hasErrors || errorMessage) && (
          <div className="error-text-wrapper">
            {
              (hasErrors && 'Password is not valid') || (errorMessage && <div>{errorMessage}</div>)
            }
          </div>
        )}
      </label>
    );
  }
};

export default PasswordField;
